import { ActionExtended } from 'src/_common/interfaces/ActionExtended';
import { User } from 'src/_common/interfaces/models/user';
import { ACTIONS, SELECTED_EVENT_STORAGE, SELECTED_PWA_STORAGE, STORAGE } from 'src/_config'

export interface UserReducer {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;

  socketContainer: null,
  loggedInFromOtherLocation: any,
}

const initialState: UserReducer = {
  user: null,
  token: null,
  isAuthenticated: false,
  socketContainer: null,
  loggedInFromOtherLocation: null,
};

const userReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.USER.LOGIN:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
      };
    case ACTIONS.USER.LOGOUT:      
      localStorage.removeItem(STORAGE);
      localStorage.removeItem(SELECTED_EVENT_STORAGE);
      localStorage.removeItem(SELECTED_PWA_STORAGE)
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
      };
    case ACTIONS.USER.ME:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    case ACTIONS.USER.SOCKET_INSTANCE_CONTAINER:
      return {
        ...state,
        socketContainer: action.payload
      };
    
    case ACTIONS.USER.UPDATE_DISPLAY_NAME:
      let displayName = action.payload
      let editedUser:any = {...state.user}
      editedUser["display_name"] = displayName
      return{
        ...state,
        user: editedUser
      }

    default:
      return state;
  }
};

export default userReducer;
